import React, { useState  } from "react";
import { useForm } from 'react-hook-form';
import masterApi from "../../services/masterApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RecordStatusEnum } from "../../enum/enums";
import Loader from "../../components/loader/Loader";

const CreateExpertise = ({ closePopin, existingData, onSaveReload }) => {
  const [error, setError] = useState(null)
  const [viewLoader, setViewLoader] = useState(false);
  const { control,setValue, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: existingData
  });
  const [isEditMode, setIsEditMode] = useState(existingData);
  const EXPERTISE_SUCCESS_MESSAGE = process.env.REACT_APP_EXPERTISE_SUCCESS_MESSAGE
  const EXPERTISE_UPDATE_SUCCESS_MESSAGE = process.env.REACT_APP_EXPERTISE_UPDATE_SUCCESS_MESSAGE
  const [recordStatus, setRecordStatus] = useState(existingData?.recordStatus || RecordStatusEnum.ACTIVE);

  
  const onSubmit = async (data) => {
    setViewLoader(true)
    try {
      let formattedData = {
        expertiseName: data.expertiseName,
        expertiseId : existingData?._id,
        recordStatus :  data.recordStatus 
      };     
      if (!isEditMode) {// add action
        const createResponse = await masterApi.createExpertise({ formattedData });
        if (createResponse?.data?.ok) {//sucessfully added user  
          setViewLoader(false)
          toast.success(EXPERTISE_SUCCESS_MESSAGE, {
            autoClose: 1000, // 1 seconds
            onClose: () => {
              closePopin(); // Close after the toast ends
            }
          });
        } else {
          setViewLoader(false)
          toast.error(createResponse?.response?.data?.message, {
            autoClose: 2000, // 1 seconds
          });
        }
      }
      else {//update action
        const expertiseId = existingData?._id;
        const updateResponse = await masterApi.updateExpertise({ expertiseId, formattedData });
        if (updateResponse?.ok) {//sucessfully added user  
          setViewLoader(false)
          toast.success(EXPERTISE_UPDATE_SUCCESS_MESSAGE, {
            autoClose: 1000, // 1 seconds
            onClose: () => {
              closePopin(); // Close after the toast ends
            }
          });
        } else {
          setViewLoader(false)
          toast.error(updateResponse?.response?.data?.message, {
            autoClose: 2000, // 1 seconds
          });
          
        }
      };
    } catch (error) {
      setViewLoader(false)
      setError('Someting went wrong!')
    }
    { onSaveReload() }

  };


  return (
    <div className="popIn-inner-wrapper">
      <div className="create-stage d-flex flex-column justify-content-between h-100">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form">
            <div className="form-group">
              <label>Expertise Name<span>*</span></label>
              <input {...register('expertiseName', { required: "Expertise name is required" })}
                type="text"
                className={`${errors.expertiseName ? 'form-control required' : 'form-control'}`}
                placeholder="Expertise name"
              ></input>

            </div>
            <div className="form-group status">
              <label>Status<span>*</span></label>
              <label className="toggle-label">
              <input 
                type="checkbox" 
                checked={recordStatus === RecordStatusEnum.ACTIVE}  // Control the checkbox state based on the enum
                onChange={(e) => {
                  const newStatus = e.target.checked ? RecordStatusEnum.ACTIVE : RecordStatusEnum.IN_ACTIVE;  // Toggle between Active and Inactive
                  setRecordStatus(newStatus);  // Update local state
                  setValue("recordStatus", newStatus);  // Update form value in react-hook-form
                }}
              />
                <div className="back">
                  <div className="toggle"></div>
                  <div className="label on">Active</div>
                  <div className="label off">Inactive</div>
                </div>
              </label>
            </div>
          </div>
          {viewLoader && <Loader />}
          <div className="action-btn">
            <button className="cancel secondary-btn" onClick={closePopin}>Cancel</button>
            <button className="save primary-btn">{isEditMode ? 'Update' : 'Save'}</button>
          </div>
        </form>        
      </div>      
    </div>
  );
};

export default CreateExpertise;
